// Centralized brand asset URLs.
// All assets are bundled with the backend at /api/static/brand/* so the site
// is fully self-contained and never depends on external CDN links.
export const BRAND = {
  LOGO: "/api/static/brand/logo.png",
  FAMILY: "/api/static/brand/family.jpg",
  SPRINTERS: "/api/static/brand/sprinters.png",
  POWERLIFTER: "/api/static/brand/powerlifter.png",
  STRENGTH_DUO: "/api/static/brand/strength_duo.png",
  COLLECTION_SHEET: "/api/static/brand/collection_sheet.jpg",
  FELICE_TESTIMONIAL: "/api/static/brand/felice_testimonial.png",
  JASMINE_TESTIMONIAL: "/api/static/brand/jasmine_testimonial.png",
  FOUNDER: "/api/static/brand/founder.png",
  LADY_STARZZ_TEAM: "/api/static/brand/lady_starzz_team.png",
  LADY_STARZZ_LOGO: "/api/static/brand/lady_starzz_logo.png",
  WSBL_LOGO: "/api/static/brand/wsbl_logo.png",
};
